import React, { Component } from 'react';
//mui
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from '@mui/material';
//i18n
import i18n from '../../i18n';
//context
import { AppDataContext } from '../../context/Context';

class ChangePasswordDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPass: null
        };
    }
    //props: open, onClose, userId
    static contextType = AppDataContext;

    handlePasswordValueChanged(event) {
        this.setState({ newPass: event.target.value });
    }

    async handleChangePassDialogSave(event) {
        let result = await this.context
            .getState()
            .server.users.changePass(this.props.userId, this.state.newPass);
        if (result.error === 'OK') {
            this.context.update({
                alertError: {
                    message: i18n.t('errors.passwordChanged'),
                    severity: 'success'
                }
            });
            this.props.onClose();
        } else {
            this.context.update({
                alertError: {
                    message: i18n.t('errors.passwordNotChanged')
                }
            });
        }
    }
    render() {
        return (
            <Dialog open={this.props.open}>
                <DialogTitle>{i18n.t('text.changePassword')}</DialogTitle>
                <DialogContent>
                    <Box component="form" noValidate autoComplete="off">
                        <TextField
                            autoFocus
                            margin="dense"
                            id="changePassField"
                            label={i18n.t('text.newPassword')}
                            type="password"
                            autoComplete="new-password"
                            defaultValue=""
                            fullWidth
                            onChange={(event) =>
                                this.handlePasswordValueChanged(event)
                            }
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={(event) => this.props.onClose(event)}>
                        {i18n.t('buttons.cancel')}
                    </Button>
                    <Button
                        onClick={(event) =>
                            this.handleChangePassDialogSave(event)
                        }
                    >
                        {i18n.t('buttons.change')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ChangePasswordDialog;
